<template>
  <div>
    <pt-modal
      ref="addEditCategoryModal"
      :close-on-outside-click="false"
      size="large"
      no-border
      class="custom-modal category-modal"
    >
      <div slot="modal-header" class="flex justify-between text-xl">
        <div class="">{{ isEdit ? 'Edit' : 'Add' }} Category</div>
        <div>
          <button @click="close">
            <i class="fa fa-times" aria-hidden="true" />
          </button>
        </div>
      </div>
      <div slot="modal-body">
        <pt-form-group :invalid-feedback="formErrors.invalid_name" class="mb-4">
          <div slot="form-group-label" class="text-black-darker text-sm font-bold mb-1">
            Category Name <span class="font-bold text-red">*</span>
          </div>
          <pt-form-input
            id="name"
            v-model="$v.categoryName.$model"
            type="text"
            placeholder="Type Category Name"
            class="w-full"
          />
        </pt-form-group>
      </div>
      <div slot="modal-footer">
        <div class="flex w-full sm:flex-col md:flex-row md:justify-end">
          <pt-button
            :disabled="isLoading"
            class="sm:w-full md:w-auto md:px-10 my-1 mr-2"
            variant="secondary-outline"
            @action="close"
          >
            Cancel
          </pt-button>
          <pt-button :disabled="isLoading" class="sm:w-full md:w-auto md:px-10 my-1" variant="primary" @action="submit">
            {{ isEdit ? 'Update' : 'Add' }}
          </pt-button>
        </div>
      </div>
    </pt-modal>
  </div>
</template>

<script>
import apiRequest from '@src/utils/apiRequest';
import { PtModal, PtButton } from '@pathao/ui-components';
import { PtFormGroup, PtFormInput } from '@pathao/ui-components/esm/FormComponents';
import { required } from 'vuelidate/lib/validators';
import { RESTO_CREATE_CATEGORY, RESTO_UPDATE_CATEGORY } from '@src/config/apiEndpoints';

export default {
  components: {
    PtModal,
    PtButton,
    PtFormGroup,
    PtFormInput,
  },
  props: {
    category: {
      type: Object,
      default: null,
    },
    isEdit: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      categoryName: null,
    };
  },
  validations: {
    categoryName: { required },
  },
  computed: {
    formErrors() {
      const errors = {};

      const hasErrorInName = this.$v.categoryName.$dirty && this.$v.categoryName.$invalid;

      if (hasErrorInName) {
        errors.invalid_name = 'Please provide a Category name';
      }

      return errors;
    },
  },
  watch: {
    category(newVal, oldVal) {
      if (this.isEdit) {
        this.populateFormData(newVal);
      }
    },
  },
  mounted() {
    if (this.isEdit) {
      this.populateFormData(this.category);
    }
  },
  methods: {
    populateFormData(category) {
      this.categoryName = category.name;
    },
    show() {
      if (this.isEdit) {
        this.populateFormData(this.category);
      } else {
        this.resetData();
      }
      this.$refs.addEditCategoryModal.showModal();
    },
    close() {
      // this.$emit('onUnavailability', !this.isSubmitClicked ? false : this.selectedValue);
      if (this.isLoading) return;
      if (!this.isEdit) {
        this.resetData();
      }
      this.$refs.addEditCategoryModal.closeModal();
    },
    resetData() {
      this.categoryName = null;
    },
    submit() {
      this.isLoading = true;

      this.$v.categoryName.$touch();

      if (this.$v.$invalid) {
        this.isLoading = false;
        this.$notification.error('Please fill up all required fields!');
        return;
      }

      let formData = new FormData();

      if (!this.isEdit) {
        formData.append('name', this.categoryName);
      }

      if (this.isEdit && this.category) {
        formData = new FormData();
        if (this.category.name !== this.categoryName) formData.append('name', this.categoryName);
      }

      let payload = {
        method: this.isEdit ? 'PATCH' : 'PUT',
        url: this.isEdit ? RESTO_UPDATE_CATEGORY.replace(':categoryId', this.category.id) : RESTO_CREATE_CATEGORY,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      };

      apiRequest(payload)
        .then(response => {
          this.$notification.success(response.data.message);
          this.isLoading = false;
          this.close();
        })
        .catch(() => {
          this.isLoading = false;
          this.$notification.error(`Failed to ${this.isEdit ? 'update' : 'create'} category`);
        });
    },
  },
};
</script>
